import React from 'react';
import { differenceInHours, formatDistanceToNow } from 'date-fns';
import { Clock } from 'lucide-react';

interface BulletinTimeDisplayProps {
  createdAt: string;
  expiresAt?: string | null;
  isUpdate: boolean;
}

const BulletinTimeDisplay = ({
  createdAt,
  expiresAt,
  isUpdate
}: BulletinTimeDisplayProps) => {
  if (!isUpdate) {
    // For regular bulletins, show time since creation if expired
    const now = new Date();
    const expiryDate = expiresAt ? new Date(expiresAt) : null;
    const creationDate = new Date(createdAt);

    // If bulletin has expired, show time since creation
    if (expiryDate && now > expiryDate) {
      return <div className="text-white/50 text-[10px] sm:text-xs italic">
          {formatDistanceToNow(creationDate, {
          addSuffix: true
        })}
        </div>;
    }

    // If not expired, show remaining time
    if (expiryDate) {
      const hoursLeft = Math.max(0, differenceInHours(expiryDate, now));
      return <div className="flex items-center gap-0.5 text-white/30 text-[9px] sm:text-[10px] py-0 mx-[7px] my-[3px]">
          <Clock className="w-2 h-2 sm:w-2.5 sm:h-2.5" />
          <span>{hoursLeft}h</span>
        </div>;
    }
  }

  // For updates, always show time since creation
  return <div className="text-white/50 text-[10px] sm:text-xs italic">
      {formatDistanceToNow(new Date(createdAt), {
      addSuffix: true
    })}
    </div>;
};

export default BulletinTimeDisplay;